import {Texture} from 'pixi.js';

export class BigWinConstants {
    public static readonly ANIMATION_NAME: string = 'big_win';
    public static readonly MAIN_SOUND: string = 'bigwin';
    public static readonly END_SOUND: string = 'bigwinend';
    public static readonly WIN_RATIO: number = 20;
    public static readonly BIG_WIN: number[] = [20, 50, 100];
    public static readonly BIG_WIN_TYPES: string[] = ['amazing', 'incredible', 'awesome'];
    public static readonly BIG_WIN_TIMINGS: any = {
        animation_delay: 0,
        particles_delay: 2200,
        skip_delay: 2200,
        duration: 18200,
        final_delay: 3000,
        final_fade: 500
    };
    public static readonly FADER: any = {
        initial_alpha: 0,
        alpha: 0.75,
        duration: 660,
        delay: 660
    };

    public static readonly PARTICLE_TYPES: any = {
        amazing: ['coin'],
        incredible: ['coin', 'yuan'],
        awesome: ['coin', 'yuan', 'diamond']

    };
    public static readonly PARTICLES_FRAMERATE: number = 25;

    public static PARTICLES_CONFIG(textures: Texture[][]): any {

        const anims = textures.map((textureSet) => ({
            framerate: 15,
            loop: true,
            textures: textureSet,
        }));

        return {
            lifetime: {
                min: 5,
                max: 5
            },
            frequency: 0.8,
            emitterLifetime: -1,
            maxParticles: 1000,
            addAtBack: false,
            particlesPerWave: 15,
            pos: {
                x: -800,
                y: -200
            },
            behaviors: [
                {
                    type: 'blendMode',
                    config: {
                        blendMode: 'normal'
                    }
                },
                {
                    type: 'moveAcceleration',
                    config: {
                        accel: {
                            x: 0,
                            y: 1000,
                           
                        },
                        maxSpeed: 0,
                        minStart: 1250,
                        maxStart: 1500
                    }
                },
                {
                    type: 'scale',
                    config: {
                        minMult: 1,
                        scale: {
                            list:[
                                {time: 0, value: 0.5},
                                {time: 1, value: 0.7}
                            ]}
                    }
                },
                {
                    type: 'colorStatic',
                    config: {color: '#e4f9ff'}
                },
                {
                    type: 'rotation',
                    config: {accel: 0, minSpeed: 0.01, maxSpeed: 0.15, minStart: 230, maxStart: 320}
                },
                {
                    type: 'animatedRandom',
                    config: {
                        anims
                    }
                },
                {
                    type: 'spawnShape',
                    config: {
                        type: 'rect',
                        data: {x: 0, y: 0, w: 1200, h: 300}
                    }
                }
            ]
        };
    }
}